import React from "react";
import { Form } from "react-bootstrap";
import moment from "moment";

import PropTypes from "prop-types";
import { useWorkOrders } from "../../../data/WorkOrdersHook";

function DiagnosisAndScheduling({ mode }) {
  const workOrdersRepository = useWorkOrders();

  const updateDiagnosis = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, diagnosis: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const workOrder = workOrdersRepository.getEntry();
  const slaHours = `${workOrder.slahours} Hours`;
  const suggestedStartBy = moment()
    .add(workOrder.slahours, "hours")
    .format("DD/MM/YYYY h:mm a");

  return (
    <div className="work-order-entry-section diagnosis-and-scheduling">
      <h3>Diagnosis And Scheduling</h3>
      <Form.Group className="mb-3" controlId="slaHoursGroup">
        <Form.Label>Start Time SLA</Form.Label>
        <Form.Control as="input" disabled value={slaHours} />
      </Form.Group>

      {mode !== "update" && (
        <Form.Group className="mb-3" controlId="suggestedStartByGroup">
          <Form.Label>Suggested Start By</Form.Label>
          <Form.Control as="input" disabled value={suggestedStartBy} />
        </Form.Group>
      )}

      <Form.Group className="mb-3" controlId="diagnosisGroup">
        <Form.Label>Diagnosis Steps</Form.Label>
        <Form.Control
          as="textarea"
          required
          rows={6}
          value={workOrder.diagnosis}
          onChange={updateDiagnosis}
        />
      </Form.Group>
    </div>
  );
}

DiagnosisAndScheduling.propTypes = {
  mode: PropTypes.oneOf(["create", "update"]).isRequired,
};

export default DiagnosisAndScheduling;
